import Keycloak from 'keycloak-js';
import { AuthClientInitOptions } from '@react-keycloak/core';

export const keycloak = Keycloak({
  url: `${process.env.REACT_APP_KEYCLOAK_URL}/auth`,
  realm: 'ceapia',
  clientId: 'prontuario-web',
});

export const keycloakConfig: AuthClientInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
};
